import React, { useState, useEffect, useContext } from "react";
import { PaymentService } from "../../../services/payment-service";
import { useHistory } from "react-router-dom";
import { DataGrid } from "@material-ui/data-grid";
import { Modal } from "react-bootstrap";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import { ToastContainer } from "react-toastify";
import TablePagination from "@material-ui/core/TablePagination";
import moment from "moment";
import AuthContext from "../../../context/auth-context";

export const Content = (props) => {
  const ctx = useContext(AuthContext);

  const format2 = "YYYY-MM-DD";
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [count, setDataCount] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const history = useHistory();

  const [setting, setSetting] = useState([]);

  const [settingID, setsettingID] = useState();

  const [submitloading, setSubmitLoading] = useState(true);

  const [state, setState] = useState(false);

  const handleShow4 = (e) => {
    setState({ show4: true });
    setsettingID(e);
  };

  const handleClose = (e) => {
    setState({ show3: false });
  };

  useEffect(() => {
    paymentSearch();
  }, [page, rowsPerPage, count]);

  const paymentSearch = async () => {
    try {
      const result = await PaymentService.paymentDetails(rowsPerPage, page);

      setSetting(result?.results);
      setDataCount(result?.pagination?.total);
    } catch (err) {
      //toast
      console.error(err);
    }
  };

  const onDelete = async () => {
    //todo extra validations
    setSubmitLoading(false);
    try {
      await PaymentService.settingDelete(settingID);

      setSubmitLoading(true);
      notify("Setting successfully deleted");
      handleClose();
      paymentSearch();
    } catch (err) {
      notifyWarning(err.response.data.message);
      setSubmitLoading(true);
      //show error toast
    }
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      flex: 1,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "amount",
      headerName: "Amount",
      flex: 5,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "client_ref",
      headerName: "Client Ref",
      flex: 4,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "created_at",
      headerName: "Created Date",
      sortable: false,
      flex: 4,
      disableClickEventBubbling: true,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return <div>{moment(params.row.created_at).format(format2)}</div>;
      },
    },
    {
      field: "status",
      headerName: "Status",
      sortable: false,
      flex: 3,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        if (params.row.status === "SUCCESS") {
          return (
            <div>
              <span className="badge badge-success">SUCCESS</span>
            </div>
          );
        } else {
          return (
            <div>
              <span className="badge badge-primary">FAILED</span>
            </div>
          );
        }
      },
    },
    {
      field: "edit",
      headerName: "Edit",
      sortable: false,
      flex: 1,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return (
          <div
            onClick={() => {
              history.push(`/payment-edit/${params.row.id}`);
            }}
            style={{ cursor: "pointer" }}
          >
            <i className="fas fa-pencil-alt text-secondary" />
          </div>
        );
      },
    },
    {
      field: "delete",
      headerName: "Delete",
      sortable: false,
      flex: 1,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return (
          <div>
            <i
              className="far fa-trash-alt ms-text-danger"
              onClick={() => {
                handleShow4(params.row.id);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        );
      },
    },
  ];

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="row">
            <div className="col-xl-12">
              <div className="ms-panel">
                <div className="ms-panel-header">
                  <div className="row">
                    <h6>Payment</h6>
                  </div>
                  <div>
                    <Modal
                      show={state.show4}
                      onHide={handleClose}
                      aria-labelledby="contained-modal-title-vcenter"
                      centered
                    >
                      <Modal.Header>
                        <h3 className="modal-title has-icon ms-icon-round ">
                          Confirm Deletion
                        </h3>
                        <button
                          type="button"
                          className="close"
                          onClick={handleClose}
                        >
                          <span aria-hidden="true">×</span>
                        </button>
                      </Modal.Header>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: "2vh",
                        }}
                      >
                        <h6 style={{ color: "red" }}>
                          Are you sure you want to remove this item ?
                        </h6>
                      </div>
                      <Modal.Footer>
                        <div className="col-md-2" hidden={submitloading}>
                          <div className="spinner spinner-7">
                            <div className="bounce1" />
                            <div className="bounce2" />
                            <div className="bounce3" />
                          </div>
                        </div>
                        <button
                          type="button"
                          className="btn btn-primary shadow-none"
                          style={{ backgroundColor: "red" }}
                          onClick={onDelete}
                        >
                          Delete
                        </button>

                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={handleClose}
                        >
                          Cancel
                        </button>
                      </Modal.Footer>
                    </Modal>
                  </div>
                </div>
                <div className="ms-panel-body">
                  <div style={{ flex: "100%"}}>
                    <DataGrid
                      rows={setting}
                      disableExtendRowFullWidth={false}
                      columns={columns}
                      pageSize={rowsPerPage}
                      pagination
                      hideFooter
                      autoHeight
                    />
                    <TablePagination
                      component="div"
                      count={count}
                      page={page}
                      onPageChange={handleChangePage}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
